import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccountCircleFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.8337 6.16637C14.6119 2.94454 9.38826 2.94454 6.16643 6.16637C2.94461 9.38818 2.9446 14.6118 6.16643 17.8336C6.2318 17.899 6.29799 17.963 6.36498 18.0257C7.32589 16.3124 9.58769 15.25 12 15.25C14.4123 15.25 16.6742 16.3124 17.6351 18.0258C17.7021 17.9631 17.7683 17.899 17.8337 17.8336C21.0555 14.6118 21.0555 9.3882 17.8337 6.16637ZM5.10577 5.10571C8.91338 1.2981 15.0867 1.2981 18.8943 5.10571C22.7019 8.91332 22.7019 15.0867 18.8943 18.8943C15.0867 22.7019 8.91336 22.7019 5.10577 18.8943C1.29816 15.0867 1.29816 8.9133 5.10577 5.10571ZM9.34833 7.34835C10.8128 5.88389 13.1872 5.88389 14.6516 7.34835C16.1161 8.81281 16.1161 11.1872 14.6516 12.6516C13.1872 14.1161 10.8128 14.1161 9.34833 12.6516C7.88387 11.1872 7.88387 8.81281 9.34833 7.34835Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgAccountCircleFilled);
export default ForwardRef;
